export default __webpack_public_path__ + "assets/03595515dc8e579c225c7ab00546b572.png";